export const WA_BROADCAST_CTA_SOURCE = {
  CMP_HEADER: "CMP_HEADER",
  SEND_MESSAGE_POPUP: "SEND_MESSAGE_POPUP",
  WA_BROADCAST_PAGE: "WA_BROADCAST_PAGE"
};

export const WA_BROADCAST_EXTENSION_INSTALLED = "waBroadCastExtensionInstalled";

export const WA_BROADCAST_EVENTS = {
  WA_BROADCAST_CTA_CLICKED: {
    name: "WA_BROADCAST_CTA_CLICKED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_POPUP_CLOSED: {
    name: "WA_BROADCAST_POPUP_CLOSED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_PAGE_LOADED: {
    name: "WA_BROADCAST_PAGE_LOADED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_INSTALL_CTA_CLICKED: {
    name: "WA_BROADCAST_INSTALL_CTA_CLICKED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_CANDIDATE_SELECTION_SHOWN: {
    name: "WA_BROADCAST_CANDIDATE_SELECTION_SHOWN",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_START_SENDING_CLICKED: {
    name: "WA_BROADCAST_START_SENDING_CLICKED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_CAMPAIGN_CREATION_SHOWN: {
    name: "WA_BROADCAST_CAMPAIGN_CREATION_SHOWN",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_TEMPLATE_SELECTED: {
    name: "WA_BROADCAST_TEMPLATE_SELECTED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_SEND_CAMPAIGN_CLICKED: {
    name: "WA_BROADCAST_SEND_CAMPAIGN_CLICKED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_SEND_CAMPAIGN_ERROR: {
    name: "WA_BROADCAST_SEND_CAMPAIGN_ERROR",
    category: "WA_BROADCAST"
  },
  WA_VIEW_ALL_BROADCAST_CLICK: {
    name: "WA_VIEW_ALL_BROADCAST_CLICK",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_VIDEO_STARTED: {
    name: "WA_BROADCAST_VIDEO_STARTED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_VIDEO_ENDED: {
    name: "WA_BROADCAST_VIDEO_ENDED",
    category: "WA_BROADCAST"
  },
  WA_BROADCAST_ZERO_CANDIDATES_REDIRECT: {
    name: "WA_BROADCAST_ZERO_CANDIDATES_REDIRECT",
    category: "WA_BROADCAST"
  }
};
